import apiClient from '../shared/services/apiClient';

const resolutionsAPI = {
  // Company Leadership
  getLeadership: (businessId, params = {}) => 
    apiClient.get('/company-leadership', { params: { business_id: businessId, ...params } }),
  
  getLeadershipById: (id) => 
    apiClient.get(`/company-leadership/${id}`),
  
  createLeadership: (data) => 
    apiClient.post('/company-leadership', data),
  
  updateLeadership: (id, data) => 
    apiClient.put(`/company-leadership/${id}`, data),
  
  deleteLeadership: (id) => 
    apiClient.delete(`/company-leadership/${id}`),
  
  // Resolutions
  getResolutions: (businessId, params = {}) => 
    apiClient.get('/resolutions', { params: { business_id: businessId, ...params } }),
  
  getResolutionById: (id) => 
    apiClient.get(`/resolutions/${id}`),
  
  createResolution: (data) => 
    apiClient.post('/resolutions', data),
  
  updateResolution: (id, data) => 
    apiClient.put(`/resolutions/${id}`, data),
  
  deleteResolution: (id) => 
    apiClient.delete(`/resolutions/${id}`),
  
  // Resolution Problems
  addProblem: (resolutionId, data) => 
    apiClient.post(`/resolutions/${resolutionId}/problems`, data),
  
  updateProblem: (resolutionId, problemId, data) => 
    apiClient.put(`/resolutions/${resolutionId}/problems/${problemId}`, data),
  
  deleteProblem: (resolutionId, problemId) => 
    apiClient.delete(`/resolutions/${resolutionId}/problems/${problemId}`),
  
  // Signatures
  signResolution: (resolutionId, data) => 
    apiClient.post(`/resolutions/${resolutionId}/sign`, data),
  
  // PDF Generation
  generatePDF: (resolutionId) => 
    apiClient.get(`/resolutions/${resolutionId}/pdf`, { responseType: 'blob' })
};

export default resolutionsAPI;

